export class Entity {
    constructor(id: number) {
        this.id = id;
    }

    id: number;
}